<template>
  <div class="container page-section verity-mt">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-12 mt-2 mb-2">
              <h3>{{ $t('label.requestNewLoan') }}</h3>
            </div>

            <div
              class="col-md-12 mt-2 mb-2"
              v-if="LoadTypeOptions && LoadTypeOptions.length > 0"
            >
              <div class="form-group">
                <label>{{ $t('label.loanType') }}</label>
                <select
                  v-model="borrow.loan_type"
                  class="form-control form-input"
                  @change="clearData"
                >
                  <option
                    :value="null"
                    disabled
                    selected
                    data-default
                  >
                    {{ $t("form.select.label.loanType") }}
                  </option>
                  <template v-for="(item, key) in LoadTypeOptions">
                    <option
                      :value="item.value"
                      :key="key"
                    >
                      {{ $t(item.label) }}
                    </option>
                  </template>
                </select>
              </div>
            </div>

            <template v-if="borrow.loan_type">
              <div class="col-md-12 mt-2 mb-2">
                <div class="form-group">
                  <label class="label-required">
                    {{ $t('form.borrow.amountBorrow') }}
                  </label>
                  <select
                    v-model="borrow.amount"
                    class="form-control form-input"
                  >
                    <option
                      :value="null"
                      disabled
                      selected
                      data-default
                    >
                      {{ $t("form.select.label.amountBorrow") }}
                    </option>
                    <template v-if="typeOfLoan === 'Payday'">
                      <template v-if="paydayLoanAmountRange.length > 0">
                        <option
                          v-for="(amount, key) in paydayLoanAmountRange"
                          :value="amount"
                          :key="key"
                        >
                          $ {{ amount }}
                        </option>
                      </template>
                    </template>
                    <template v-else-if="typeOfLoan === 'Personal'">
                      <template v-if="personalLoanAmountRange.length > 0">
                        <option
                          v-for="(amount, key) in personalLoanAmountRange"
                          :value="amount"
                          :key="key"
                        >
                          $ {{ amount }}
                        </option>
                      </template>
                    </template>
                    <template v-else-if="typeOfLoan === 'Purchasing'">
                      <template v-if="purchasingLoanAmountRange.length > 0">
                        <option
                          v-for="(amount, key) in purchasingLoanAmountRange"
                          :value="amount"
                          :key="key"
                        >
                          $ {{ amount }}
                        </option>
                      </template>
                    </template>
                    <template v-else-if="typeOfLoan === 'Pawn'">
                      <template v-if="pawnLoanAmountRange.length > 0">
                        <option
                          v-for="(amount, key) in pawnLoanAmountRange"
                          :value="amount"
                          :key="key"
                        >
                          $ {{ amount }}
                        </option>
                      </template>
                    </template>
                  </select>
                  <span
                    class="label-error"
                    v-if="messageValidate && messageValidate.hasOwnProperty('amount')"
                  >
                    {{ messageValidate.amount[0] }}
                  </span>
                </div>
              </div>

              <div class="col-md-12 mt-2 mb-2">
                <div class="form-group">
                  <label class="label-required">
                    {{ typeOfLoan === 'Payday' ? $t('form.borrow.periodDay') : $t('form.borrow.periodMonth') }}
                  </label>
                  <select
                    v-model="borrow.duration"
                    class="form-control form-input"
                  >
                    <option
                      :value="null"
                      disabled
                      selected
                      data-default
                    >
                      {{ $t("form.select.label.duration") }}
                    </option>
                    <template v-if="typeOfLoan === 'Payday'">
                      <template v-if="paydayLoanDurationRange.length > 0">
                        <option
                          v-for="(duration, key) in paydayLoanDurationRange"
                          :value="duration"
                          :key="key"
                        >
                          {{ duration }} {{ $t('calender.day') }}
                        </option>
                      </template>
                    </template>
                    <template v-else-if="typeOfLoan === 'Personal'">
                      <template v-if="personalLoanDurationRange.length > 0">
                        <option
                          v-for="(duration, key) in personalLoanDurationRange"
                          :value="duration"
                          :key="key"
                        >
                          {{ duration }} {{ $t('calender.month') }}
                        </option>
                      </template>
                    </template>
                    <template v-if="typeOfLoan === 'Purchasing'">
                      <template v-if="purchasingLoanDurationRange.length > 0">
                        <option
                          v-for="(duration, key) in purchasingLoanDurationRange"
                          :value="duration"
                          :key="key"
                        >
                          {{ duration }} {{ $t('calender.month') }}
                        </option>
                      </template>
                    </template>
                    <template v-if="typeOfLoan === 'Pawn'">
                      <template v-if="pawnLoanDurationRange.length > 0">
                        <option
                          v-for="(duration, key) in pawnLoanDurationRange"
                          :value="duration"
                          :key="key"
                        >
                          {{ duration }} {{ $t('calender.month') }}
                        </option>
                      </template>
                    </template>
                  </select>
                  <span
                    class="label-error"
                    v-if="messageValidate && messageValidate.hasOwnProperty('duration')"
                  >
                    {{ messageValidate.duration[0] }}
                  </span>
                </div>
              </div>

              <div class="col-md-12 mt-2 mb-2">
                <div class="form-group">
                  <label class="label-required">{{ $t('form.borrow.string.whyAreYouNeedTheLoan?') }}</label>
                  <select
                    v-model="borrow.purpose_loan_id"
                    class="form-control form-input"
                  >
                    <option
                      value=""
                      disabled
                      selected
                      data-default
                    >
                      {{ $t("form.select.label.reason") }}
                    </option>
                    <template
                      v-if="loanTypes && Array.isArray(loanTypes) && loanTypes.length > 0"
                    >
                      <optgroup
                        v-for="(item, key) in loanTypes"
                        :key="key"
                        :label="$i18n.locale === 'en' ? item.name : item.name_kh ? item.name_kh : item.name"
                      >
                        <template v-if="item.children.length > 0">
                          <template v-for="(child, index) in item.children">
                            <option
                              :value="child.id"
                              :key="index"
                            >
                              <template v-if="$i18n.locale === 'en'">
                                {{ child.name }}
                              </template>
                              <template v-else>
                                {{ child.name_kh ? child.name_kh : child.name }}
                              </template>
                            </option>
                          </template>
                        </template>
                      </optgroup>
                    </template>
                  </select>
                  <span
                    class="label-error"
                    v-if="messageValidate && messageValidate.hasOwnProperty('purpose_loan_id')"
                  >
                    {{ messageValidate.purpose_loan_id[0] }}
                  </span>
                </div>
              </div>

              <div class="col-md-12 mt-2 mb-2 btn-new-loan">
                <button
                  class="btn btn-cash-hero btn-wh-44 float-right"
                  @click="requestNewLoan()"
                >
                  <i class="fa fa-save" />
                  {{ $t('global.btn.submit') }}
                </button>
                <button
                  class="btn btn-light btn-wh-44 float-right"
                  @click="back()"
                >
                  <i class="far fa-times-circle" />
                  {{ $t('global.btn.cancel') }}
                </button>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-5 block-img d-none d-md-block">
          <img
            src="img/cashHero_2.png"
            alt=""
            class="img-size"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { dataOptions } from './dataOptions'

export default {
  name: 'NewLoan',
  metaInfo: {
    title: 'Request New Loan',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'User request new loan.' }
    ]
  },
  data () {
    return {
      LoadTypeOptions: [
        { value: 'Payday', label: 'label.payDayLoan' },
        { value: 'Personal', label: 'label.personalLoan' },
        { value: 'Purchasing', label: 'label.purchasing' },
        { value: 'Pawn', label: 'label.pawn' }
      ],
      paydayLoan: dataOptions.paydayLoan,
      personalLoan: dataOptions.personalLoan,
      purchasing: dataOptions.purchasing,
      pawn: dataOptions.pawn,
      purchaseItemOptions: dataOptions.purchaseItemOptions,
      typeOfCollateralOptions: dataOptions.typeOfCollateralOptions,
      borrow: {
        amount: null,
        duration: null,
        loan_type: null,
        purpose_loan_id: '',
        start: this.$moment().format('YYYY-MM-DD')
      },
      messageValidate: null,
      loanTypes: []
    }
  },
  watch: {
    '$i18n.locale': {
      handler: function (val, oldVal) {
        this.messageValidate = null
      }
    }
  },
  computed: Object.assign(mapState({
    data_borrow: state => state.borrow
  }), {
    typeOfLoan () {
      return this.borrow.loan_type
    },
    // Payday Loan
    paydayLoanAmountRange () {
      return new Array(Math.floor(((this.paydayLoan.amount.max - this.paydayLoan.amount.min) / this.paydayLoan.amount.interval) + 1)).fill().map((_, index) => this.paydayLoan.amount.min + (index * this.paydayLoan.amount.interval))
    },
    paydayLoanDurationRange () {
      return new Array(Math.floor(((this.paydayLoan.duration.max - this.paydayLoan.duration.min) / this.paydayLoan.duration.interval) + 1)).fill().map((_, index) => this.paydayLoan.duration.min + (index * this.paydayLoan.duration.interval))
    },

    // Personal Loan
    personalLoanAmountRange () {
      const personalAmountRange = new Array(Math.floor(((this.personalLoan.amount.max - this.personalLoan.amount.min) / this.personalLoan.amount.interval) + 1)).fill().map((_, index) => this.personalLoan.amount.min + (index * this.personalLoan.amount.interval))
      if (!(personalAmountRange.includes(this.personalLoan.amount.max))) {
        personalAmountRange.push(this.personalLoan.amount.max)
      }
      return personalAmountRange
    },
    personalLoanDurationRange () {
      return new Array(Math.floor(((this.personalLoan.duration.max - this.personalLoan.duration.min) / this.personalLoan.duration.interval) + 1)).fill().map((_, index) => this.personalLoan.duration.min + (index * this.personalLoan.duration.interval))
    },

    // Purchasing Loan
    purchasingLoanAmountRange () {
      const purchasingAmountRange = new Array(Math.floor(((this.purchasing.amount.max - this.purchasing.amount.min) / this.purchasing.amount.interval) + 1)).fill().map((_, index) => this.purchasing.amount.min + (index * this.purchasing.amount.interval))
      if (!(purchasingAmountRange.includes(this.purchasing.amount.max))) {
        purchasingAmountRange.push(this.purchasing.amount.max)
      }
      return purchasingAmountRange
    },
    purchasingLoanDurationRange () {
      return new Array(Math.floor(((this.purchasing.duration.max - this.purchasing.duration.min) / this.purchasing.duration.interval) + 1)).fill().map((_, index) => this.purchasing.duration.min + (index * this.purchasing.duration.interval))
    },

    // Pawn Loan
    pawnLoanAmountRange () {
      const pawnAmountRange = new Array(Math.floor(((this.pawn.amount.max - this.pawn.amount.min) / this.pawn.amount.interval) + 1)).fill().map((_, index) => this.pawn.amount.min + (index * this.pawn.amount.interval))
      if (!(pawnAmountRange.includes(this.pawn.amount.max))) {
        pawnAmountRange.push(this.pawn.amount.max)
      }
      return pawnAmountRange
    },
    pawnLoanDurationRange () {
      return new Array(Math.floor(((this.pawn.duration.max - this.pawn.duration.min) / this.pawn.duration.interval) + 1)).fill().map((_, index) => this.pawn.duration.min + (index * this.pawn.duration.interval))
    }
  }),
  methods: {
    getLoanValueAndDuration (model, route, code, only_value = false) {
      this.$isLoading(true)
      this.$axios.post(this.$base_api + route)
        .then((response) => {
          if (response.data.code === code && response.data.data !== null) {
            const result = response.data.data
            if (result.min_amount) model.amount.min = result.min_amount
            if (result.max_amount) model.amount.max = result.max_amount
            if (!only_value) {
              if (result.min) model.duration.min = result.min
              if (result.max) model.duration.max = result.max
            }
          }
        }).finally(() => {
          this.$isLoading(false)
        })
    },
    back () {
      sessionStorage.removeItem('typeOfLoan')
      this.$router.back()
    },
    getLoanTypes () {
      this.$isLoading(true)
      this.$axios.get(this.$base_api + '/api/v1/loan/get-loan-types')
        .then((response) => {
          if (response.data.code === 1) {
            this.loanTypes = response.data.data
          }
        }).finally(() => {
          this.$isLoading(false)
        })
    },
    checkUserHasLoadpanding () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/borrow/check-account-has-loan-pending')
        .then((response) => {
          if (response.data.code === 1) {
            const result = response.data.data.has_pending_loan
            this.$store.dispatch('checkUserHasPendingLoan', result)
            if (result) {
              this.$router.push({ name: 'profile', params: { activeTabs: 'profile' } })
            }
          }
        })
    },
    clearData () {
      this.borrow.duration = null
      this.borrow.amount = null
      this.messageValidate = null
    },
    requestNewLoan () {
      this.messageValidate = null
      this.$isLoading(true)
      this.$axios.post(this.$base_api + '/api/v1/frontend/loan/request-new-loan', this.borrow)
        .then((response) => {
          if (response.data.code === 1) {
            this.$router.push({ name: 'profile', params: { activeTabs: 'profile' } })
            this.$swal.fire({
              type: 'success',
              title: this.$t('label.requestNewLoan'),
              text: this.$t('string.newLoan')
            })
          } else {
            this.messageValidate = response.data.message
          }
        }).catch(({ response }) => {
          if (this.$i18n.locale === 'km') {
            this.$swal.fire({
              type: 'warning',
              title: this.$t('label.requestNewLoan'),
              text: response.data.message_km
            })
          } else {
            this.$swal.fire({
              type: 'warning',
              title: this.$t('label.requestNewLoan'),
              text: response.data.message_en
            })
          }
        }).finally(() => {
          sessionStorage.removeItem('typeOfLoan')
          this.$isLoading(false)
        })
    }
  },
  beforeMount () {
    if (!localStorage.getItem('token')) {
      // change redirect to home page
      this.$router.push({ name: this.$default_page })
    }
    if (!sessionStorage.getItem('typeOfLoan')) {
      this.$router.push({ name: 'profile', params: { activeTabs: 'profile' } })
    }
  },
  mounted () {
    if (localStorage.getItem('token')) {
      if (sessionStorage.getItem('typeOfLoan')) {
        this.getLoanTypes()
        this.getLoanValueAndDuration(this.paydayLoan, '/api/v1/interest-rate/get-interest-rates', 1, true)
        this.getLoanValueAndDuration(this.personalLoan, '/api/v1/interest-rate/personal-loan/get-interest-rates', 1)
        this.getLoanValueAndDuration(this.purchasing, '/api/v1/interest-rate/purchasing/get-interest-rates', 200)
        this.getLoanValueAndDuration(this.pawn, '/api/v1/interest-rate/pawn/get-interest-rates', 1)
      }
      if (this.data_borrow.amountBorrow) this.borrow.amount = this.data_borrow.amountBorrow
      if (this.data_borrow.amountDate) this.borrow.duration = this.data_borrow.amountDate
      if (this.data_borrow.loanType) this.borrow.loan_type = this.data_borrow.loanType
    }
  }
}
</script>

<style scoped>
.btn-wh-44 {
  width: 25%;
  height: 44px;
}

.btn-new-loan button {
  margin-right: 5px;
}

.btn-new-loan button:first-child {
  margin-right: 0;
}

.block-img {
  padding-top: 50px;
  text-align: right;
}

.img-size {
  width: 60%;
}

@media screen  and (max-width: 991px) {
  .img-size {
    width: 75%
  }

  .btn-wh-44 {
    width: 30%;
    height: 44px;
  }
}

@media screen and (max-width: 767px) {
  .block-img {
    text-align: center;
  }
}

@media (max-width: 576px) {
  .btn-wh-44 {
    width: 100%;
    height: 44px;
  }

  .btn-new-loan button {
    margin: 5px 0;
  }
}
</style>
